module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("9xeQ7"))).then(() => parcelRequire('5l444'));